/**
 * @example
 *   Input: { a: 'b', c: 'd' }
 *   Output: 'a="b" c="d"'
 */
export function objToHtmlElementAttrs(
  attrs: Record<string, string | number | false | undefined | null>,
): string {
  return Object.entries(attrs)
    .map(([key, val]) => (val === undefined ? key : `${key}="${val}"`))
    .join(' ');
}
